let remindmeButton = document.querySelector('#notify__button');
function makeXhr(method, url, data,domain) {
  var xhttp = new XMLHttpRequest();
  xhttp.open(method, url, true);
  xhttp.setRequestHeader('Content-type', 'application/json');
  xhttp.setRequestHeader('x-shopify-shop-domain', domain);
  xhttp.onload = function () {
    var status = xhttp.status;
    var response = xhttp.response;

    const responseText = document.querySelector('#notify__master .response-message--text');

    if (status == 200) {
      responseText.textContent = 'Your Whatsapp notification request has been registered';
      responseText.classList.add('success');
    } else {
      responseText.textContent = 'Your Whatsapp notification request has been failed';
      responseText.classList.add('failed')
    }
    remindmeButton.classList.remove('is-loading');
    remindmeButton.textContent = 'REMIND ME';
  };
  xhttp.send(data ? JSON.stringify(data) : null);
}

function notifyOnWhatsApp(){
  let info = document.getElementById('notify__text');
  let productId = info.getAttribute('data-productId');
  let variantId = info.getAttribute('data-variantId');
  let proudctTitle = info.getAttribute('data-productTitle');
  let currentVariantId = document.getElementsByName("id")[0].value
  let nationalCode = document.getElementById('countryCode');
  let domain = window.location.hostname;
  if(info.value){
    const data ={
      'phone' : nationalCode.value.toString() +info.value,
      'variant_id':currentVariantId,
      'product_id':productId,
      'product_title' : proudctTitle,
      'variant_url' : window.location.href
    }
    makeXhr('POST','https://iy08ni8pq5.execute-api.ap-south-1.amazonaws.com/api/notify/api',data,domain);
    remindmeButton.classList.add('is-loading');
    remindmeButton.textContent = '';
    console.log(remindmeButton.textContent);
  }else{
    alert('Please provide the phone number');
  }
  
}